var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay_H"},[_c('el-container',[_c('el-header',{staticStyle:{"height":"100px"}},[_c('Head')],1),_c('el-main',{staticClass:"pay_main_body"},[_c('Pay_jtzz'),_c('Footer')],1)],1),_c('Xuanfuret')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }